module.exports = __webpack_public_path__ + "img/ic_manage1.8357b4d9.png";